export enum DocumentConstants {
  APPOINTMENT_SETTINGS = "appointmentSettings",
  APPOINTMENT = "appointment",
  PATIENT = "patient",
  ADMIN_DATE_SELECTOR = "adminDateSelector",
  CHARGE = "charge",
  PRODUCT_CONFIGURATION = "productConfiguration",
}
